"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDefaultLinePoint = exports.getDefaultLine = exports["default"] = void 0;
var _generateObjectId = _interopRequireDefault(require("./generateObjectId"));
var getDefaultLine = exports.getDefaultLine = function getDefaultLine() {
  /**
  * Why do we add more than 1 points by default to the new line?
  *
  * There is bug with victory-native that will throw an error if
  * there aren't two data points in the array.
  */
  return {
    _id: (0, _generateObjectId["default"])(),
    deleted: false,
    title: '',
    description: '',
    points: [getDefaultLinePoint(), getDefaultLinePoint(), getDefaultLinePoint()]
  };
};
var getDefaultLinePoint = exports.getDefaultLinePoint = function getDefaultLinePoint() {
  return {
    _id: (0, _generateObjectId["default"])(),
    label: '',
    y: null,
    x: null
  };
};
var _default = exports["default"] = {
  getDefaultLine: getDefaultLine,
  getDefaultLinePoint: getDefaultLinePoint
};